export const RESPONSE_TOOLBAR_LOCALE_ZHCHT = {
    more: 'æ´å¤',
};
